import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import { dataMapRef } from './consts';

export default grapesjs.plugins.add('gjs-data-map', (editor, opts) => {
  let options = opts || {};

  let defaults = {
    pfx: dataMapRef,
    blocks: [dataMapRef],
    defaultStyle: true,
    labelMap: 'Google Map',
    labelMapCategory: 'CMS',
    labelFinderName: 'Filters',
    labelColName: 'Collection',
    labelFieldName: 'Collection Fields',
  };

  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }

  loadComponents(editor, options);
  loadBlocks(editor, options);
});
